/*eslint-disable*/
export default shippingFreeReturns => {
  let $popup = $('body').find('.shipping-free-returns.popup')
  $(window).load(() => {
    $popup.find('.tip-close a').on("click touchstart", function () {
      $popup.css('display', 'none')
      $('body').css('overflow', 'auto')
      $('#wrapper').css('overflow', 'auto')
      $("#wrapper .content.container").css('overflow', 'auto')
      $('body').unbind('click.shippingFreeReturns touchstart.shippingFreeReturns');
    });
  })

  $(shippingFreeReturns).click((event) => {
    $("#wrapper .content.container").css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    $popup.css('display', 'block')
    $popup.removeClass('hidden')
    setTimeout(() => {
      $('body').bind('click.shippingFreeReturns touchstart.shippingFreeReturns', function (e) {
        e.stopImmediatePropagation()
        if (!$(e.target).closest('.shipping-free-returns.popup:not(.template)').length) {
          $popup.css('display', 'none')
          $('body').unbind('click.shippingFreeReturns touchstart.shippingFreeReturns');
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $("#wrapper .content.container").css('overflow', 'auto')
        }
      });
    }, 10)
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/shipping-free-returns.js